<template>
  <div class="reveal black">
    <v-btn class="my-2 mx-2" small fab dark :color="getThemeColor" fixed>
      <v-icon @click="goBack()">mdi-backburger</v-icon>
    </v-btn>
    <div class="slides">
      <section data-transition="convex">{{$route.params.lessonInfo.lessonName}}</section>
      <section
        v-for="(slide,ind) in getComponents"
        v-html="slide.content"
        :key="ind+Math.random()+Math.random()"
        data-transition="zoom"
      ></section>
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  mounted() {
    this.lesson = this.$route.params;

    axios
      .postDataWithToken(
        "/auth/get-slides-from-db",
        { lessonId: this.$route.params.lessonInfo.lesson },
        this.getAccessToken
      )
      .then(response => {
        this.$store.commit("initializeComponents", response);
      });
  },

  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    }
  },
  data() {
    return {
      lesson: null
    };
  },

  methods: {
    goBack() {
      this.$router.push({
        path: "/topics/" + this.lesson.lessonInfo.subjectId
      });
    }
  }
};
</script>

<style>
</style>